import { render, staticRenderFns } from "./pill.vue?vue&type=template&id=f9b55974&scoped=true&"
import script from "./pill.js?vue&type=script&lang=js&"
export * from "./pill.js?vue&type=script&lang=js&"
import style0 from "./pill.scss?vue&type=style&index=0&id=f9b55974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b55974",
  null
  
)

export default component.exports